'use client'
import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const HomeUnderDestinationAd = ({ lang, dictionary }) => {
  const pathname = usePathname()
  const adBanner = 'https://media.travelm.de/travelm-bucket/2b5e48f6c75b36a348a5f3b668134ca4.webp'
  if (pathname.includes('trending-article')) {
    return null
  }

  return (
    <section id="ad__banner">
      <div className="ad-banner__main container dflex cursor-pointer">
        <Link href="/de-DE/trending-article/besondere-erlebnisse-und-echte-begegnungen">
          <Image src={adBanner} alt="Anzeige" width={1600} height={800} />
          <p className="ad__text">{dictionary?.advertisement?.title}</p>
        </Link>
      </div>
    </section>
  )
}

export default HomeUnderDestinationAd
